module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch3_20210921052649_T.088becbe.jpg";